import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  draft: {
    width: '100%',
  },
}));
